import { Box, BoxProps, Typography } from '@mui/material';
import React from 'react';
import { marked } from 'marked';

import { useServerTranslation } from 'hooks/useServerTranslation';
import { OrganisationPublicContent } from '../../generated/graphql';
import { ProfileGreeting } from './ProfileGreeting';
import { ProfileDescription } from './ProfileDescription';
import { ProfileRole } from './ProfileRole';
import { ProfileFullName } from './ProfileFullName';
import { ConsultantProfilePhoto } from './ConsultantProfilePhoto';

type ProfilePresentationProps = {
    content: OrganisationPublicContent;
    boxProps?: BoxProps;
};

export function ProfilePresentation({ content, boxProps }: ProfilePresentationProps) {
    const { t } = useServerTranslation();

    const {
        first_name,
        middle_name,
        last_name,
        presentation,
        title_name_long,
        title_name_short,
        email,
        mobile,
        profile_photo_path,
    } = content;

    return (
        <Box {...boxProps}>
            <ConsultantProfilePhoto imageSrc={profile_photo_path || undefined} />
            <ProfileFullName
                sx={{ marginBottom: '20px' }}
            >
                {`${first_name} ${middle_name} ${last_name}`}
            </ProfileFullName>
            <ProfileRole sx={{ marginBottom: '15px' }}>{title_name_long || title_name_short}</ProfileRole>
            <Typography>{email}</Typography>
            <Typography sx={{ marginBottom: '40px' }}>{mobile}</Typography>
            <ProfileGreeting sx={{ marginBottom: '20px' }}>{t('profile.greeting')}</ProfileGreeting>
            <ProfileDescription>{marked.parse(presentation)}</ProfileDescription>
        </Box>
    );
}
